var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 37,
    rx: 18.5,
    stroke: "#E2E8F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28064_98244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 13.1654C18.3583 13.1654 17.8333 13.6904 17.8333 14.332V17.832H14.3333C13.6916 17.832 13.1666 18.357 13.1666 18.9987C13.1666 19.6404 13.6916 20.1654 14.3333 20.1654H17.8333V23.6654C17.8333 24.307 18.3583 24.832 18.9999 24.832C19.6416 24.832 20.1666 24.307 20.1666 23.6654V20.1654H23.6666C24.3083 20.1654 24.8333 19.6404 24.8333 18.9987C24.8333 18.357 24.3083 17.832 23.6666 17.832H20.1666V14.332C20.1666 13.6904 19.6416 13.1654 18.9999 13.1654ZM18.9999 7.33203C12.5599 7.33203 7.33325 12.5587 7.33325 18.9987C7.33325 25.4387 12.5599 30.6654 18.9999 30.6654C25.4399 30.6654 30.6666 25.4387 30.6666 18.9987C30.6666 12.5587 25.4399 7.33203 18.9999 7.33203ZM18.9999 28.332C13.8549 28.332 9.66659 24.1437 9.66659 18.9987C9.66659 13.8537 13.8549 9.66536 18.9999 9.66536C24.1449 9.66536 28.3333 13.8537 28.3333 18.9987C28.3333 24.1437 24.1449 28.332 18.9999 28.332Z",
    fill: "#395BA9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28064_98244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBtn);
export default __webpack_public_path__ + "static/media/add_btn.bc3d27b388e6aff771ca408c5df821ec.svg";
export { ForwardRef as ReactComponent };